import type { System as SystemDto } from "@istari/istari-client";

import type { System } from "~/systems/model/system";

export function toSystem(dto: SystemDto): System {
  return {
    id: dto.id,
    name: dto.name,
    description: dto.description,
    archiveStatus: dto.archiveStatus,
  };
}
